<template>
    <div>

        <HeaderBreadcrumbs
            :items="[
                { label: 'Coupon', to: { name: 'coupon' } },
                { label: this.name },
            ]"
            :title="this.name"
        />

        <div class="bg-white p-4 my-3 rounded-lg shadow-sm">
            <div class="flex justify-between items-center">
                <div>
                    <h4 class="text-gray-900 font-semibold text-xl">Coupon Details</h4>
                </div>
                <div>
                    <button class="bg-blue-700 mx-2 px-2.5 py-1.5 text-white rounded-lg">
                        <div class="flex items-center justify-between">
                            <svg class=" dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                <path fill-rule="evenodd"
                                    d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                                    clip-rule="evenodd" />
                                <path fill-rule="evenodd"
                                    d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                                    clip-rule="evenodd" />
                            </svg>
                            <router-link class="text-white w-full block list-none ml-2 mt-0"
                                :to="{ path: `/coupon/edit/${this.$route.params.id}` }">
                                <span class="mt-0">Edit</span>
                             </router-link>

                        </div>
                    </button>
                </div>
            </div>
            <div class="flex justify-start mt-2">
                <div class="w-1/2">
                    <div class="block">
                        <label class="text-gray-800 text-base font-semibold mb-1">Coupon Name</label>
                        <div class="block">
                            <span class="text-gray-600">{{ this.name }}</span>
                        </div>
                    </div>
                    <div class="block mt-2 w-full">
                        <label class="text-gray-800 text-base font-semibold mb-1">Description</label>
                        <div class="block w-full relative pr-4">
                            <p class="text-gray-600 transition-all duration-300 m-0 overflow-hidden"
                                :class="{ 'h-20 transition-all': !showFullText, 'h-10 transition-all': this.description < 50 }">
                                {{ this.description }}
                            </p>
                            <button v-if="this.description.length > 150" @click="toggleReadMore"
                                class="text-gray-800 font-semibold mt-1 float-right">
                                <span class="flex items-center">
                                    {{ !showFullText ? "Read More " : "Read Less " }}
                                    <svg v-if="!showFullText" class="w-5 h-5 text-gray-800 dark:text-white"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m19 9-7 7-7-7" />
                                    </svg>
                                    <svg v-if="showFullText" class="w-5 h-5 text-gray-800 dark:text-white"
                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m5 15 7-7 7 7" />
                                    </svg>

                                </span>

                            </button>
                        </div>
                    </div>
                    <div class="flex justify-betweens mt-2 w-full">
                        <div class="w-1/2">
                            <div class="block">
                                <label class="text-gray-800 text-base font-semibold mb-1">Client/Buyer Name</label>
                                <div class="block">
                                    <span class="text-gray-600">{{ this.client_name }}</span>
                                </div>
                            </div>
                            <div class="block mt-2">
                                <label class="text-gray-800 text-base font-semibold mb-1">Start Date</label>
                                <div class="block">
                                    <span class="text-gray-600">{{ this.formatDate(this.start_date) }}</span>
                                </div>
                            </div>
                            <div class="block mt-2">
                                <label class="text-gray-800 text-base font-semibold mb-1">Platform</label>
                                <div class="block">

                                    <span class="text-gray-600"> {{ this.platforms }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2">
                            <div class="block">
                                <label class="text-gray-800 text-base font-semibold mb-1">Coupon Price</label>
                                <div class="block">
                                    <span class="text-gray-600">{{ formatCurrency(this.price, 'IDR') }}</span>
                                </div>
                            </div>
                            <div class="block mt-2">
                                <label class="text-gray-800 text-base font-semibold mb-1">End Date</label>
                                <div class="block">
                                    <span class="text-gray-600">{{ this.formatDate(this.end_date) }}</span>
                                </div>
                            </div>
                            <div class="block mt-2">
                                <label class="text-gray-800 text-base font-semibold mb-1">Product/Offer to Be
                                    Redeemed</label>
                                <div class="block">
                                    <span class="text-gray-600">{{ this.offer_name }}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="w-1/2">
                    <div class="block">
                        <label class="text-gray-800 text-base font-semibold mb-1">Status</label>
                        <div class="block">
                            <span class="text-green-800 bg-green-100 font-semibold px-2.5 py-1 rounded-lg"
                                v-if="this.status">Active</span>
                            <span v-else class="text-gray-800 bg-gray-100 font-semibold px-2.5 py-1 rounded-lg">
                                Inactive
                            </span>
                        </div>
                    </div>
                    <div class="block mt-2">
                        <label class="text-gray-800 text-base font-semibold mb-1">Created Date</label>
                        <div class="block">
                            <span class="text-gray-600">{{ this.formatDate(this.created) }}</span>
                        </div>
                    </div>
                    <div class="block mt-2">
                        <label class="text-gray-800 text-base font-semibold mb-1"> Last Modified Date</label>
                        <div class="block">
                            <span class="text-gray-600">{{ this.formatDate(this.modified) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white p-4 my-4 rounded-lg shadow-sm">
            <h4 class="text-gray-900 font-semibold text-xl mb-4">Coupon Code Details</h4>
            <div class="flex justify-between items-center  align-middle mb-4">
                <div class="block relative">
                    <input class="bg-gray-100 rounded-lg py-2 px-4 border w-96"
                        placeholder='Search Coupon Code & Reedemed By' v-model="filter"
                        @input="searchByCodeCoupon" />
                    <button v-if="filter"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>
                    <svg v-if="!filter" class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 right-3" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                </div>



                <div class="button_donwload">
                    <button
                    class="bg-blue-700 rounded-lg px-4 py-2 text-white flex justify-between " @click="downloadCSV"
                    :class="{ 'opacity-50 pointer-events-none': couponscode.length === 0}"
                    >
                        <svg class="w-5 h-5 text-white dark:text-white mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"/>
                        </svg>

                        Download as CSV

                    </button>
                </div>
            </div>
            <div class="w-full">
                <TableCoupontCode :currentpage="currentPage" :perpage="perPage" :couponcode="couponscode"
                    :isLoading="isLoading" />
            </div>

            <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center mt-3">
                <div class="font-semibold">
                    <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
                        class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
                </div>
                <div class="mb-2">
                    <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
                        class="rounded-lg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TableCoupontCode from '../../components/coupon/table-coupont-code.vue';
import HeaderBreadcrumbs from "@/components/HeaderBreadcrumbs.vue";
import moment from 'moment';
export default {
    name: "CouponViewDetail",
    components: {
        TableCoupontCode,
        HeaderBreadcrumbs
    },
    computed: {
        ...mapState({
            //isError: (state) => state.coupons.isError,
            item: (state) => state.coupons.item,
            totalRows: (state) => state.coupons.totalRows,
            couponscode: (state) => state.coupons.couponscode,
            isLoading: (state) => state.coupons.isLoading,
            errorMessage: (state) => state.coupons.errorMessage,
            successMessage: (state) => state.coupons.successMessage,
        }),
    },
    data() {
        return {
            name: "",
            currentPage: 1,
            perPage: 20,
            description: "",
            client_name: "",
            start_date: "",
            debounceTimer: null,
            end_date: "",
            created: "",
            platforms: "",
            filter: null,
            price: '',
            status: '',
            showFullText: false,
            offer_name: "",
            modified: ""
        }
    },
    watch: {
        errorMessage: function () {
            if (!this.errorMessage) return;
        },
        currentPage: function () {
            this.fetchCouponCode();
        },
        item: function () {
            if (!Object.keys(this.item).length) return;
            this.setDataCouponId();
        },
        successMessage: function () {
            if (!this.successMessage) return;
        },
    },
    created() {
        let id = this.$route.params.id;
        this.fetchCouponDetailByid(id);
    },
    mounted() {
        this.fetchCouponCode();
    },

    methods: {
        ...mapActions("coupons", [
            "fetchCouponDetailByid", "fetchCouponCodeId","downloadCSVCoupon"
        ]),
        setDataCouponId() {
            const data = this.item;
            this.name = data.name
            this.description = data.description
            this.client_name = data.client_name
            this.start_date = data.start_date
            this.platforms = data.platforms
            this.price = data.price
            this.end_date = data.end_date
            this.offer_name = data.offer.name
            this.status = data.is_active
            this.created = data.created
            this.modified = data.modified
        },
        formatDate(tgl) {
            if (tgl) {
                return moment(tgl).format("DD MMMM YYYY HH:mm:ss");
            }
            return "-";
        },
        fetchCouponCode() {
            let payload = {
                id: this.$route.params.id,
                page: this.currentPage,
                limit: this.perPage,
            };
            this.fetchCouponCodeId(payload);
        },
        formatCurrency(amount, currency = "IDR") {
            const formatter = new Intl.NumberFormat("id-ID", { style: "currency", currency });
            return formatter.format(amount).replace(/\D00(?=\D*$)/, "");
        },
        reset() {
            this.$router.push("/coupons");
        },
        actionReset() {
            this.fetchCouponCode()
            this.filter = ''
        },
        toggleReadMore() {
            this.showFullText = !this.showFullText;
        },
        async downloadCSV() {
            this.downloadCSVCoupon(this.$route.params.id)
        },
        searchByCodeCoupon() {
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
        if (this.filter.trim() === '') {
            this.fetchCouponCode()
            return;
        }
        let payload = {
            id: this.$route.params.id,
            page: 1,
            limit: this.perPage,
        };
        payload.search = this.filter;

        await this.fetchCouponCodeId(payload);
        }, 500);
  },


    }
}

</script>
